export const CREATE_GROUP_DIALOG_ROOT = 'create-group-dialog-root';
export const CREATE_GROUP_DIALOG_SUBMIT_BUTTON =
  'create-group-dialog-submit-button';
